import MapDefinition from "../model/MapDefinition";

export default class CurrentMapChangedEvent {
    /**
     * @constructor
     * @param {string} type 
     * @param {MapDefinition} mapDefinition 
     */
    constructor(type, mapDefinition) {
        this.type = type;
        this.mapDefinition = mapDefinition;
    }
}

CurrentMapChangedEvent.CURRENT_MAP_CHANGED = "CurrentMapChangedEvent.CURRENT_MAP_CHANGED";